
// =========================
// FILTERS
// =========================
import './app/filters/getProp5Images.filter';
import './app/filters/currencyKH.filter';
import './app/filters/commaToDot.filter';

// =========================
// Bootstrap frameworks
// =========================
import './app/main';

const Vue = window.Vue;

Vue.component('carousel', () => import('./app/components/Carousel.vue'));
